exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-42871e9a]{color:#000;display:inline-block;width:120px}.count[data-v-42871e9a]{font-size:14px}.list[data-v-42871e9a]{list-style:none;padding-left:0}.list li[data-v-42871e9a]{margin:0;text-align:center;float:left;padding:15px 15px 15px 0}.avatar[data-v-42871e9a]{width:64px;height:64px;border-radius:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"autoprefixer":false,"sourceMap":false,"minimize":true}!./~/ream/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42871e9a","scoped":true,"hasInlineConfig":true}!./~/ream/~/vue-loader/lib/selector.js?type=styles&index=0!./en/about/contributors.vue
// module id = 1414
// module chunks = 171